<template>
    <div class="protocolo-ocorrencia-esfinge-page">
      <div class="az-form-content pa-3">
      <v-layout wrap align-center>
        <v-flex xs12 class="pr-sm-2">
          <v-data-table
          :headers="headers"
          :items="items"
          class="az-table-list"
          :pagination.sync="pagination"
          :rows-per-page-items="rowsPerPageItems"
          :total-items="totalElements"
          :loading="loading"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{ props.item.tipo }}</td>
              <td>
                <div v-if="props.item.codigoDescricao && props.item.codigoDescricao.length > 30">
                  <ver-mais :tamanho="30" :descricao="props.item.codigoDescricaoCompleta" />
                </div>
                <span v-else-if="props.item.codigoDescricao && props.item.codigoDescricao.length > 0">
                  {{ props.item.codigoDescricao }}
                </span>
                <span v-else>--</span>
              </td>
              <td>{{ props.item.tipoOcorrencia }}</td>
              <td>
                <div v-if="props.item.protocolo && props.item.protocolo.length > 50">
                  <ver-mais :tamanho="50" :descricao="props.item.protocolo" />
                </div>
                <span v-else>{{ props.item.protocolo }}</span>
              </td>
              <td>
                <div v-if="props.item.justificativa && props.item.justificativa.length > 30">
                  <ver-mais :tamanho="30" :descricao="props.item.justificativaCompleta" />
                </div>
                <span v-else-if="props.item.justificativa && props.item.justificativa.length > 0">
                  {{ props.item.justificativa }}
                </span>
                <span v-else>--</span>
              </td>
              <td class="text-xs-center">
                <v-btn icon @click="abrirDialogoCancelamento(props.item)">
                  <v-icon color="grey lighten-1">cancel</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <v-alert :value="true" color="grey lighten-4" class="ma-0">
              Nenhuma ocorrência encontrada.
            </v-alert>
          </template>
        </v-data-table></v-flex>
      </v-layout>

      <mensagem-confirmacao
        :exibirMensagem="mostrarDialogoCancelarOcorrencia"
        titulo="Cancelar Ocorrência"
        :textoSecundario="mensagemConfirmacaoCancelamento"
        @confirmado="confirmarCancelamento"
        @recusado="fecharDialogoCancelamento"
      />

      <v-btn outline color="primary" class="mt-4 mb-8" @click="voltar">
        CANCELAR
      </v-btn>
    </div></div>
</template>

<script>
import VerMais from '@/views/components/VerMais.vue'
import MensagemConfirmacao from '@/views/components/MensagemConfirmacao.vue'
import { actionTypes } from '@/core/constants'
import {mapState} from 'vuex'

export default {
    name: 'ProtocoloOcorrencia',
    components: { VerMais, MensagemConfirmacao },
    data() {
        return {
            pagination: {
                sortBy: null,
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            rowsPerPageItems: [5, 10, 20],
            headers: [
                { text: 'Tipo', value: 'tipo', sortable: true, class: 'primary--text' },
                { text: 'Código/Descrição', value: 'codigoDescricao', sortable: false, class: 'primary--text' },
                { text: 'Tipo Ocorrência', value: 'tipoOcorrencia', sortable: true, class: 'primary--text' },
                { text: 'Nº Protocolo', value: 'protocolo', sortable: true, class: 'primary--text' },
                { text: 'Justificativa', value: 'justificativa', sortable: false, class: 'primary--text' },
                { text: 'Ações', value: 'acoes', sortable: false, class: 'primary--text', align: 'center' }
            ],
            items: [],
            totalElements: 0,
            processo: '',
            loading: false,
            mostrarDialogoCancelarOcorrencia: false,
            ocorrenciaSelecionada: null,
            compraDiretaId: null,
            carregouOcorrenciasInicial: false
        }
    },
    async mounted() {
        this.compraDiretaId = this.$route.params.id
        await this.$store.dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, this.compraDiretaId)
        await this.buscarOcorrencias()
        this.carregouOcorrenciasInicial = true
    },
    watch: {
        pagination: {
            handler() {
                if (!this.carregouOcorrenciasInicial) return
                this.buscarOcorrencias()
            },
            deep: true
        }
    },
    computed: {
        ...mapState(['resumoCompraDireta']),
        mensagemConfirmacaoCancelamento() {
            return 'Atenção! você está prestes a cancelar o envio da ocorrência! Após a confirmação os dados não poderão ser recuperados. Deseja realmente confirmar esta ação?'
        }
    },
    methods: {
        voltar() {
            if (this.$router && window.history.length > 1) {
                this.$router.back()
                return
            }
            if (this.$router) {
                this.$router.push({ name: 'ExecucaoCompraDireta', params: { id: this.compraDiretaId } })
            }
        },
        async buscarOcorrencias() {
            try {
                this.loading = true
                const params = {
                    compraDiretaId: this.compraDiretaId,
                    page: this.pagination.page - 1,
                    rowsPerPage: this.pagination.rowsPerPage,
                    sortBy: this.pagination.sortBy,
                    sort: this.pagination.descending ? 'DESC' : 'ASC'
                }

                const data = await this.$store.dispatch(
                    actionTypes.ESFINGE.BUSCAR_LISTAGEM_PAGINADA_PROTOCOLOS_OCORRENCIA,
                    params
                )

                this.items = data.itens.map(item => ({
                    itemId: item.itemId,
                    loteId: item.loteId,
                    compraDiretaId: item.compraDiretaId,
                    tipo: item.tipo || '--',
                    codigoDescricao: item.codigo && item.descricao ? `${item.codigo} - ${item.descricao}` : '',
                    codigoDescricaoCompleta: item.codigo && item.descricao ? `${item.codigo} - ${item.descricao}` : '',
                    tipoOcorrencia: item.situacao || '--',
                    protocolo: item.protocolo || '--',
                    justificativa: item.justificativa || '',
                    justificativaCompleta: item.justificativa || ''
                }))

                this.totalElements = data.totalElements
                this.processo = data.processo || ''
            } catch (error) {
                this.mostrarNotificacaoErro(error.message || 'Erro ao buscar ocorrências')
            } finally {
                this.loading = false
            }
        },
        abrirDialogoCancelamento(ocorrencia) {
            this.ocorrenciaSelecionada = ocorrencia
            this.mostrarDialogoCancelarOcorrencia = true
        },
        async confirmarCancelamento() {
            try {
                const { itemId, loteId, compraDiretaId, protocolo } = this.ocorrenciaSelecionada || {}

                let itemLoteCompraDiretaId = null
                let identificador = null

                if (loteId) {
                    itemLoteCompraDiretaId = loteId
                    identificador = 'LOTE'
                } else if (itemId) {
                    itemLoteCompraDiretaId = itemId
                    identificador = 'ITEM'
                } else if (this.compraDiretaId || compraDiretaId) {
                    itemLoteCompraDiretaId = this.compraDiretaId || compraDiretaId
                    identificador = 'COMPRA'
                }

                await this.$store.dispatch(
                    actionTypes.ESFINGE.CANCELAR_OCORRENCIA,
                    { compraDiretaId: this.compraDiretaId, numeroProtocolo: protocolo, itemLoteCompraDiretaId, identificador }
                )
                this.mostrarNotificacaoSucesso('Ocorrência cancelada com sucesso.')
                this.fecharDialogoCancelamento()
                await this.buscarOcorrencias()
            } catch (error) {
                this.mostrarNotificacaoErro(error.message || 'Erro ao cancelar ocorrência')
            }
        },
        fecharDialogoCancelamento() {
            this.mostrarDialogoCancelarOcorrencia = false
            this.ocorrenciaSelecionada = null
        }
    }
}
</script>

<style scoped>

.protocolo-ocorrencia-esfinge-page .botao-primario {
  padding: 0 25px;
  border: 1px solid #1976d2 !important;
  background-color: #1976d2 !important;
  color: #fff !important;
  box-sizing: border-box;
  margin-left: 15px !important;
}

.az-table-list >>> table {
  table-layout: fixed;
  width: 100%;
}

</style>
